import React, { useState } from "react";
import { Label, Modal, ModalBody } from "reactstrap";
import { ReactComponent as UploadIcon } from "assets/img/svg/upload.svg";
import { ReactComponent as DonloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { ReactComponent as PdfIcon } from "assets/img/svg/pdfIcon.svg";
import { bankNameRequiredPayModeList, labelSyle } from "./constant";
import { downloadAttachment } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/utils";
import DocUploadModal from "../../../studentCharges/studentChargesDetails/paymentMode/DocUploadModal";
import AButton from "../../../../common/form-fields-mui/AButton";
import { paymentCodeMapping } from "views/pages/manage/masters/studentFinancials/paymentCollection/manage-receipts/viewReceipt/constant";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const UploadChequeEpmr = ({
  openUploadChequePopUp,
  closePopup,
  isView = false,
  setCollectPayment,
  paymentMode,
  bankDropdown,
  collectPayment
}) => {
  const [paymentModeForm, setPaymentModeForm] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const isBankNameRequired = bankNameRequiredPayModeList.includes(paymentMode)
  const isFileUploadRequired = ["CHKL","DD"].includes(paymentMode);
  const bankDropdownHandler = (bankDropValueName) => {
    const bankName = bankDropValueName?.value;
    setCollectPayment((prev) => [
      { ...prev[0], bankName: bankName, bankNameCustom: bankName },
    ]);
  };

  const saveHandler = ()=>{
    if(isBankNameRequired && collectPayment?.length>0 && !collectPayment[0]?.bankNameCustom )
       return failureToast("Please select a bank")
    
       closePopup(false)
  }

  return (
    <Modal
      size="md"
      isOpen={openUploadChequePopUp}
      style={{ minWidth: "580px" }}
    >
      <ModalBody>
        <div className="d-flex gap-md align-items-center">
          <div>
           {isBankNameRequired && <AAutoComplete
              label="Select Bank"
              labelStyle={labelSyle}
              placeholder="Select bank"
              currentValue={paymentModeForm?.bank}
              handleChange={(value) => {
                bankDropdownHandler(value);
              }}
              items={bankDropdown}
              isMulti={false}
              isShowCount={false}
              style={{
                control: {
                  height: "47px",
                  width: "265px",
                  borderRadius: "5px",
                },
              }}
              isInputChange={true}
              isDisabled={isView}
            />}
          </div>
          {isFileUploadRequired &&
          <div style={{ width: "265px" }}>
            <Label style={{ ...labelSyle, marginTop: "7px" }}>
              {" "}
              Please upload {paymentCodeMapping[paymentMode]} photo
            </Label>
            {paymentModeForm?.paymentModeAttachmentS3Key || isView ? (
              <div style={{ gap: "10px" }} className="d-flex mt-2">
                {paymentModeForm?.fileName && (
                  <span>
                    <PdfIcon height={22} width={18} />
                  </span>
                )}

                <span className="large-semi-bold">
                  {isView ? (
                    <span className="regular-large-bold label-color">
                      {paymentModeForm?.fileName ?? "-"}
                      {paymentModeForm?.fileName && (
                        <DonloadIcon
                          width="24px"
                          height="24px"
                          onClick={() =>
                            downloadAttachment(paymentModeForm?.fileName)
                          }
                        />
                      )}
                    </span>
                  ) : (
                    paymentModeForm?.fileName
                  )}
                </span>
                {!isView && (
                  <span>
                    <EditIcon
                      onClick={() => {
                        setIsOpen(true);
                      }}
                    />
                    {/* <AButton onClick={() => closePopup(false)}>Save</AButton> */}
                  </span>
                )}
              </div>
            ) : (
              <div
                className="upload-btn "
                onClick={() => {
                  setIsOpen(true);
                }}
              >
                <UploadIcon /> Upload
              </div>
            )}
            <DocUploadModal
              open={isOpen}
              setOpen={setIsOpen}
              saveHandler={(s3Key, fileName) => {
                setIsOpen(false);
                setPaymentModeForm({
                  ...paymentModeForm,
                  paymentModeAttachmentS3Key: s3Key,
                  fileName: fileName,
                });
                setCollectPayment((prev) => [
                  { ...prev[0], paymentModeAttachmentS3Key: s3Key },
                ]);
              }}
              acceptedFileTypes={[".jpg", ".jpeg", ".png", ".pdf"]}
              maxUploadFileSize={2}
              serviceName={"PAYMENT_COLLECTION_ATTACHMENTS"}
              uniqueKeyParameter={"paymentCollectionImage"}
              uploadedFileS3Key={paymentModeForm?.paymentModeAttachmentS3Key}
              uploadedFileName={paymentModeForm?.fileName}
              modalTitle={"Upload Cheque photo"}
            />
          </div>
}
        </div>
        <AButton updatedStyle = {{minWidth:"100px"}} className ="mt-2"  variant="primary_filled" onClick={()=>saveHandler(false)}>
          Save
        </AButton>
      </ModalBody>
    </Modal>
  );
};
export default UploadChequeEpmr;
